var map = {
	"./2015/15-1.png": "1365",
	"./2016/16-1.png": "ebf5",
	"./2016/16-2.png": "888c",
	"./2017/17-1.png": "ce17",
	"./2017/17-2.png": "3b21",
	"./2018/18-1.png": "b782",
	"./2018/18-2.png": "0f32",
	"./2018/18-3.png": "0bdd",
	"./2018/18-4.png": "02e1",
	"./2018/18-5.png": "8cb5",
	"./2019/19-1.png": "76f5",
	"./2019/19-2.png": "32c8",
	"./2019/19-3.png": "2433",
	"./2019/19-4.png": "8be6",
	"./2020/20-1.png": "eda2",
	"./2020/20-2.png": "8121",
	"./2020/20-3.png": "3931",
	"./2020/20-4.png": "bcc3",
	"./2020/20-5.png": "8f9a",
	"./2021/21-1.png": "ec93",
	"./2021/21-2.png": "568b",
	"./2022/22-1.png": "20cf",
	"./2022/22-2.png": "0df6",
	"./2022/22-3.png": "b5b9",
	"./2022/22-4.png": "5136",
	"./2023/23-1.png": "6a7d",
	"./2023/23-2.png": "11ce",
	"./2023/23-3.png": "a7b5",
	"./2023/23-4.png": "82d5",
	"./2023/23-5.png": "a5bf",
	"./2023/23-6.png": "3dc0",
	"./2024/24-1.png": "1504",
	"./2024/24-2.png": "85d1",
	"./2024/24-3.png": "1c9c",
	"./2024/24-4.png": "8161",
	"./2024/24-5.png": "49db",
	"./2024/24-6.png": "0cdd",
	"./2024/24-7.png": "638f",
	"./arr_left.png": "c5b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a8f";